/*
 * @Description: 市场营销-接口管理模块
 * @Author: mdb
 * @Date: 2022-06-13 16:49:55
 * @LastEditTime: 2023-06-15 16:15:14
 * @LastEditors: cxh
 */
import request from '@/utils/request'
import { AxiosResult, IDParams, DropListType } from '@/typings/common'
import {
  MarketingManageParams,
  MarketingManageListItem,
  MarketingManageResult,
  MarketingManageEditParams,
  MarketingManageStatusParams,
  ActivityCodeParams,
  ActivityCodeResult,
  ActivityCodeEditParams,
  TemplateParams,
  TemplateResult,
  TemplateEditParams,
  AppidSubmitParams,
  BusinessCardParams,
  BusinessCardListResult,
  BusinessCardEditParams
} from '@/typings/api/marketingManage'

/**
 * 获取标签管理列表数据
 */
export function tagsManageList(params?: MarketingManageParams) {
  return request.get<MarketingManageResult, MarketingManageResult>('/zbu/api/label/gets', { params })
}
/**
 * 添加标签
 */
export function tagsManageAdd(data?: MarketingManageEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/label/add', data)
}
/**
 * 编辑标签
 */
export function tagsManageEdit(data?: MarketingManageEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/label/update', data)
}
/**
 * 删除标签
 */
export function tagsManageDelete(data?: IDParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/label/delete', data)
}
/**
 * 启用/停用标签
 */
export function tagsManageModify(data?: MarketingManageStatusParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/label/modify', data)
}
/**
 * 查询下拉框标签列表
 */
export function parentLabelList(params?: { id?: number }) {
  return request.get<AxiosResult<DropListType>, AxiosResult<DropListType>>('/zbu/api/label/getDropList', { params })
}
/**
 * 查询标签详情
 */
export function tagsManageDetails(params: IDParams) {
  return request.get<MarketingManageListItem, MarketingManageListItem>('/zbu/api/label/get', { params })
}

/**
 * 合作人伙伴列表
 */
export function partnerGet(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/partner/gets', { params })
}
/**
 * 合作人伙伴详情
 */
export function partnerDetail(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/partner/get', { params })
}
/**
 * 合作人伙伴导出
 */
export function partnerExport(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partner/export', data)
}
/**
 * 合作人伙伴新增
 */
export function partnerAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partner/add', data)
}
/**
 * 合作人伙伴编辑
 */
export function partnerEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partner/update', data)
}
/**
 * 合作人伙伴删除
 */
export function partnerDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partner/delete', data)
}
/**
 * 合作人伙伴对接人新增
 */
export function partnerContactAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerContact/add', data)
}
/**
 * 合作人伙伴对接人编辑
 */
export function partnerContactEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerContact/update', data)
}
/**
 * 合作人伙伴对接人删除
 */
export function partnerContactDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerContact/delete', data)
}
/**
 * 合作人伙伴对接人列表
 */
export function partnerContactList(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/partnerContact/gets', { params })
}

/**
 * 合作人伙伴对接人详情
 */
export function partnerContactDetail(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/partnerContact/gets', { params })
}

/**
 * 合作人伙伴市场活动列表
 */
export function partnerActivityList(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/partnerActivity/gets', { params })
}
/**
 * 合作人伙伴市场活动新增
 */
export function partnerActivityAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerActivity/add', data)
}
/**
 * 合作人伙伴市场活动编辑
 */
export function partnerActivityEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerActivity/update', data)
}

/**
 * 合作人伙伴市场活动删除
 */
export function partnerActivityDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerActivity/delete', data)
}

/**
 * 合作人伙伴维护记录列表
 */
export function partnerFollowRecordList(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/partnerFollowRecord/gets', { params })
}
/**
 * 合作人伙伴维护记录编辑
 */
export function partnerFollowRecordEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerFollowRecord/update', data)
}
/**
 * 合作人伙伴维护记录新增
 */
export function partnerFollowRecordAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerFollowRecord/add', data)
}
/**
 * 合作人伙伴维护记录对接人下拉框
 */
export function partnerGetDropList(params: any) {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/partnerContact/getDropList', { params })
}
/**
 * 合作人伙伴维护记录删除
 */
export function partnerFollowRecordDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/partnerFollowRecord/delete', data)
}

/** *************************************************** 活码管理 ***************************************************/
// 获取活码管理列表数据
export function activityList(data?: ActivityCodeParams) {
  return request.post<ActivityCodeResult, ActivityCodeResult>('/zbu/api/activity/qrcode/page/list', data)
}
// 查询下拉框合作伙伴列表
export function partnerDropList() {
  return request.get<AxiosResult, AxiosResult>('/zbu/api/partner/getDropList')
}
// 创建活码
export function activityCreate(data?: ActivityCodeEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/create', data)
}

// 创建并提交活码
export function activityCreateAndSubmit(data?: ActivityCodeEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/createAndSubmit', data)
}

// 编辑活码
export function activityOAUpdate(data?: ActivityCodeEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/oa/update', data)
}

// 编辑活码
export function activitySaveDraft(data?: ActivityCodeEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/saveDraft', data)
}

// 撤回OA申请
export function activityRetract(data?: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/retract', data)
}

// 编辑活码
export function activityUpdate(data?: ActivityCodeEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/update', data)
}
// 删除活码
export function activityDelete(data: { activityQrcodeId: number | string }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/delete', data)
}
// 活码详情
export function activityDetail(data: { activityQrcodeId: number | string }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/detail', data)
}
// 启用活码
export function activityEnable(data: { activityQrcodeId: number | string }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/enable', data)
}
// 禁用活码
export function activityDisabled(data: { activityQrcodeId: number | string }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/disabled', data)
}
// 关联名片
export function activityBusinessCard(data: { activityQrcodeId: string; businessCardIdList: string[] }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/relBusinessCard', data)
}
// 关联名片回显
export function showRelBusinessCard(data: { activityQrcodeId: string }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/showRelBusinessCard', data)
}

/** ******************************************************** 模板管理 **********************************************************/
// 获取模板管理列表数据
export function templateList(data?: TemplateParams) {
  return request.post<TemplateResult, TemplateResult>('/zbu/api/activity/template/page/list', data)
}
// 创建模板
export function templateCreate(data: TemplateEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/template/create', data)
}
// 编辑模板
export function templateUpdate(data: TemplateEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/template/update', data)
}
// 模板详情
export function templateDetail(data: { templateId: number }) {
  return request.post<AxiosResult<TemplateEditParams>, AxiosResult<TemplateEditParams>>(
    '/zbu/api/activity/template/detail',
    data
  )
}
// 删除模板
export function templateDelete(data: { templateId: number }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/template/delete', data)
}

/**
 * 线索管理列表
 */
export function clueGet(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/page/list', data)
}
/**
 * 线索合并
 */
export function clueMerge(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/batch/merge', data)
}
/**
 * 线索转为无效线索
 */
export function clueToInvalid(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/change/invalid', data)
}
/**
 * 线索转为有效线索
 */
export function clueToValid(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/change/valid', data)
}
/**
 * 线索转为未来线索
 */
export function clueToFuture(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/change/future', data)
}
/**
 * 线索新增
 */
export function clueAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/internal/create', data)
}
/**
 * H5扫码-线索新增
 */
export function clueActivityAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/activity/create', data)
}

export function ofbuClueActivityAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/clue/activity/create', data)
}

/**
 * 线索删除
 */
export function clueDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/delete', data)
}
/**
 * 线索详情
 */
export function clueDetail(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/detail', data)
}
/**
 * 线索导出
 */
export function clueExport(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/export', data)
}
/**
 * 线索导入
 */
export function clueImport(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/import', data)
}
/**
 * 线索投放
 */
export function cluePush(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/push', data)
}
/**
 * 线索编辑
 */
export function clueEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/update', data)
}
/**
 * 线索联系人列表
 */
export function zbuContactList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/contact/page/list', data)
}
/**
 * 线索联系人新增
 */
export function zbuContactAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/contact/create', data)
}
/**
 * 线索跟踪联系人新增
 */
export function zbuTrackContactAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/push/track/append/contact', data)
}
/**
 * 线索联系人删除
 */
export function zbuContactDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/contact/delete', data)
}

/**
 *线索联系人推送
 */
export function zbuContactPush(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/contact/push', data)
}

/**
 * 线索联系人编辑
 */
export function zbuContactEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/contact/update', data)
}
/**
 * 线索管理操作日志
 */
export function operateList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/operate/log/page/list', data)
}
/**
 * 线索投放列表查询
 */
export function cluePushRecordList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/push/record/page/list', data)
}
/**
 * 线索关联
 */
export function clueRelate(data: any, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/relate', data, custom)
}
/**
 * 线索跟踪列表查询
 */
export function clueTrackList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/push/track/page/list', data)
}
/**
 * 线索跟踪详情
 */
export function clueTrackDetail(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/push/track/detail', data)
}
/**
 * 线索撤回
 */
export function clueTrackRecall(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clue/push/track/recall', data)
}
/**
 * appid列表查询
 */
export function getAppidList(data?: any) {
  return request.get<AxiosResult, AxiosResult>('/base/api/externalApp/all', data)
}
/**
 * appid报存
 */
export function saveAppid(data: AppidSubmitParams) {
  return request.post<AxiosResult, AxiosResult>('/base/api/externalApp/save', data)
}
/**
 * appid修改
 */
export function updateAppid(data: AppidSubmitParams) {
  return request.post<AxiosResult, AxiosResult>('/base/api/externalApp/update', data)
}
/**
 * appid删除
 */
export function deleteAppid(data: { id: number }) {
  return request.post<AxiosResult, AxiosResult>('/base/api/externalApp/delete', data)
}
/**
 * appid重置
 */
export function resetAppid(data: { id: number }) {
  return request.post<AxiosResult, AxiosResult>('/base/api/externalApp/reset', data)
}
/**
 * 外部应用接口日志
 */
export function externalAppLogList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/base/api/externalAppLog/findByPage', data)
}
export function getexternalAppLogList() {
  return request.get<AxiosResult, AxiosResult>('/base/api/externalApp/all')
}

/** *************************************************** 名片管理 ***************************************************/
// 获取名片管理列表数据
export function businessCardList(data: BusinessCardParams) {
  return request.post<BusinessCardListResult, BusinessCardListResult>('/zbu/api/businessCard/queryPage', data)
}
// 创建名片数据
export function businessCardCreate(data: BusinessCardEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/businessCard/create', data)
}
// 修改名片数据
export function businessCardUpdate(data: BusinessCardEditParams) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/businessCard/update', data)
}
// 删除名片数据
export function businessCardDel(data: { id: string }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/businessCard/delete', data)
}
// 获取名片详情数据
export function businessCardDetail(data: { id: string }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/businessCard/detail', data)
}
// 下拉获取名片数据
export function queryComboBoxList() {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/businessCard/queryComboBoxList')
}
/** *************************************************** 线索自动分配 ***************************************************/
// 获取线索自动分配列表
export function clueReceiveGet(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clueReceive/findByPage', data)
}
// 获取线索自动分配列表
export function clueReceiveAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clueReceive/save', data)
}
// 获取线索自动分配列表
export function clueReceiveEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clueReceive/update', data)
}

export function clueReceiveDelete(data: { id?: number }) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/clueReceive/delete', data)
}

/**
 * 查询活码列表
 */
export function queryMarketActivityList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/zbu/api/activity/qrcode/list', data)
}
